<div class="glass-card rounded-4 p-4 mb-4">

  <!-- HEADER -->
  <h6 class="fw-semibold text-white text-xs mb-3 d-flex align-items-center gap-2">
    <i class="bi bi-calendar-week text-primary fs-6"></i>
    Today's Shift Schedule
  </h6>

  <!-- EMPTY STATE -->
  <div
    v-if="!has_shifts"
    class="text-center py-3 text-white-50 text-xs"
  >
    No shift data available.
  </div>

  <!-- SHIFT LIST -->
  <div v-else class="d-flex flex-column gap-2">

    <div
      v-for="(shift, index) in shifts"
      :key="index"
      class="doc-item rounded-4 px-3 py-2 d-flex justify-content-between align-items-center"
    >

      <!-- LEFT: ROLE + TIME -->
      <div>
        <p class="text-white fw-semibold text-xs mb-1">
          {{ shift.role }}
        </p>
        <p class="text-white-50 text-xxs mb-0">
          <i class="bi bi-clock me-1"></i>
          {{ shift.time }}
        </p>
      </div>

      <!-- RIGHT: PERSONNEL COUNTER -->
      <div>
        <span
          class="badge bg-primary bg-opacity-25 text-primary text-xxs px-3 py-2 rounded-3"
        >
          <i class="bi bi-people-fill me-1"></i>
          {{ shift.personnel }}
        </span>
      </div>

    </div>

  </div>

</div>
